const AUTH_LOCAL_STORAGE_KEY = 'B_Token';
const getAuth = () => {
    if (!localStorage) {
        return;
    }
    const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
    if (!lsValue) {
        return;
    }
    try {
        const b_token = lsValue.startsWith('"') && lsValue.endsWith('"') 
    ? lsValue.slice(1, -1) 
    : lsValue;
        const auth = b_token  
        if (auth) {
            // You can easily check auth_token expiration also
            return auth;
        }
    }
    catch (error) {
        console.error('AUTH LOCAL STORAGE PARSE ERROR', error);
    }
};
const setAuth = (auth) => {
    if (!localStorage) {
        return;
    }
    try {
        const lsValue = JSON.stringify(auth);
        localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
        localStorage.setItem('lastActivity', new Date().getTime().toString())

}
    catch (error) {
    console.error('AUTH LOCAL STORAGE Save ERROR', error);
}
};
const removeAuth = () => {
    if (!localStorage) {
        return;
    }
    try {
        localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
    }
    catch (error) {
        console.error('AUTH LOCAL STORAGE REMOVE ERROR', error);
    }
};
export function setupAxios(axios) {
    axios.defaults.headers.Accept = 'application/json';
    axios.interceptors.request.use((config) => {
        const auth = getAuth();
        if (auth && auth.api_token) {
            config.headers.Authorization = `Bearer ${auth.api_token}`;
        }
        return config;
    }, (err) => Promise.reject(err));
}
export { getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY };
